import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'
import { AppHttpConfig as API } from '../../../services/httpConfig'
import hasObjectData from '../../../utils/hasObjectData'
import queryStringBuilder, { QueryParams } from '../../../utils/queryStringBuilder'
import showResponseError from '../../../utils/showResponseError'
import { IPilgrimInitialState, SearchPilgrimList } from './types'
import { PilgrimUrl } from './urls'

const initialState: IPilgrimInitialState = {
  loading: false,
  searchPilgrim: {
    currentPage: 1,
    loading: false,
    pilgrimList: { total: 0, data: [] },
    isViewPilgrimDeatil: false,
  },
}
// search pilgrim
export const searchPilgrim = createAsyncThunk<SearchPilgrimList, QueryParams>(
  'pilgrim/searchPilgrim',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${PilgrimUrl.SearchPilgrim}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

const pilgrimSlice = createSlice({
  name: 'pilgrim',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.searchPilgrim.currentPage = action.payload
    },
    setViewPilgrimDetails: (state, action: PayloadAction<boolean>) => {
      state.searchPilgrim.isViewPilgrimDeatil = action.payload
    },
    clearSearchPilgrim: (state) => {
      state.searchPilgrim.pilgrimList = { total: 0, data: [] }
      state.searchPilgrim.currentPage = 1
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IPilgrimInitialState>) => {
    builder.addCase(searchPilgrim.pending, (state) => {
      state.searchPilgrim.loading = true
    })
    builder.addCase(
      searchPilgrim.fulfilled,
      (state, action: PayloadAction<SearchPilgrimList, any>) => {
        state.searchPilgrim.loading = false
        state.searchPilgrim.pilgrimList = action.payload
      },
    )
    builder.addCase(searchPilgrim.rejected, (state) => {
      state.searchPilgrim.loading = false
    })
  },
})

export const { setCurrentPage, clearSearchPilgrim, setViewPilgrimDetails } = pilgrimSlice.actions

export default pilgrimSlice.reducer
